import { createAPIClient as o } from "./bonuses/create-api-client.js";
import { createAPIClient as s } from "./casino/create-api-client.js";
import { createAPIClient as a } from "./identity-management/create-api-client.js";
import { createAPIClient as c } from "./profiles/create-api-client.js";
import { createAPIClient as r } from "./transactions-management/create-api-client.js";
import { createAPIClient as l } from "./wallets/create-api-client.js";
import { createAPIClient as m } from "./limits/create-api-client.js";
import { createAPIClient as p } from "./payments/create-api-client.js";
import { createAPIClient as C } from "./promotions/create-api-client.js";
import { createAPIClient as A } from "./sports/create-api-client.js";
import { createAPIClient as P } from "./verifications/create-api-client.js";
import { createAPIClient as I } from "./exclusions/create-api-client.js";
import { createAPIClient as f } from "./dynamic-lists/create-api-client.js";
import { createAPIClient as x } from "./campaign/create-api-client.js";
import { createPlatformContext as e } from "../provider/create-platform-context.js";
const t = {
  bonuses: e(),
  casino: e(),
  "identity-management": e(),
  limits: e(),
  profiles: e(),
  wallets: e(),
  payments: e(),
  promotions: e(),
  "transactions-management": e(),
  sports: e(),
  verifications: e(),
  exclusions: e(),
  "dynamic-lists": e(),
  campaign: e()
}, q = Object.keys(t).reduce(
  (n, i) => (n.push([i, t[i]]), n),
  []
), z = o({
  context: t.bonuses
}), B = s({
  context: t.casino
}), D = a({
  context: t["identity-management"]
}), E = m({
  context: t.limits
}), F = c({
  context: t.profiles
}), G = l({
  context: t.wallets
}), H = p({
  context: t.payments
}), J = C({
  context: t.promotions
}), K = A({
  context: t.sports
}), Q = P({
  context: t.verifications
}), R = I({
  context: t.exclusions
}), T = r({
  context: t["transactions-management"]
}), U = f({
  context: t["dynamic-lists"]
}), V = x({
  context: t.campaign
});
export {
  q as allServices,
  z as bonusApiClient,
  V as campaignApiClient,
  B as casinoApiClient,
  U as dynamicListsApiClient,
  R as exclusionsApiClient,
  D as identityManagementApiClient,
  E as limitsApiClient,
  H as paymentsApiClient,
  F as profilesApiClient,
  J as promotionsApiClient,
  K as sportsApiClient,
  T as transactionsManagementApiClient,
  Q as verificationsApiClient,
  G as walletsApiClient
};
